module.exports = __webpack_public_path__ + "img/historie2.56572376.jpg";